/**
 * @generated SignedSource<<d2de4073d74d9afabb948b063d199ec1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductizedService_productizedService$data = {
  readonly introductionVideo: {
    readonly isEnabled: boolean;
    readonly video: {
      readonly uid: string;
    };
  } | null;
  readonly slug: string;
  readonly updatedAt: ContraAPIScalars.DateTime;
  readonly userProfile: {
    readonly avatarImage: {
      readonly id: string;
      readonly uid: string;
      readonly url: string;
    } | null;
    readonly id: string;
    readonly visitorCanEdit: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceWorkWithMe_userProfile">;
  };
  readonly visitorCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceCTAs_productizedService" | "ProductizedServiceDeliverables_productizedService" | "ProductizedServiceDetails_productizedService" | "ProductizedServiceExampleProjects_productizedService" | "ProductizedServiceIndustries_productizedService" | "ProductizedServiceMoreServices_productizedService" | "ProductizedServicePrice_productizedService" | "ProductizedServiceSkillsTools_productizedService" | "ProductizedServiceTabs_productizedService" | "ProductizedServiceWorkWithMe_productizedService" | "ServiceBanner_productizedService" | "ServicePageHeader_productizedService" | "ServicePageReviews_productizedService">;
  readonly " $fragmentType": "ProductizedService_productizedService";
};
export type ProductizedService_productizedService$key = {
  readonly " $data"?: ProductizedService_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedService_productizedService">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visitorCanEdit",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uid",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductizedService_productizedService",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "userProfile",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductizedServiceWorkWithMe_userProfile"
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ContraImage",
          "kind": "LinkedField",
          "name": "avatarImage",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServicePrice_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServiceDeliverables_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServiceExampleProjects_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServiceMoreServices_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServiceDetails_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServiceIndustries_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServiceSkillsTools_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServiceCTAs_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ServiceBanner_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ServicePageReviews_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ServicePageHeader_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServiceTabs_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServiceWorkWithMe_productizedService"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IntroductionVideo",
      "kind": "LinkedField",
      "name": "introductionVideo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ContraVideo",
          "kind": "LinkedField",
          "name": "video",
          "plural": false,
          "selections": [
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};
})();

(node as any).hash = "f0150f7907a644be8a747da4fe7e087d";

export default node;
